
import { useState } from "react";
import { Menu } from "antd";
import { Link, NavLink, useLocation } from "react-router-dom";
import Dashboard01 from "../../assets/images/icon/dashboard.svg";
import Logo from "../../assets/images/logo-circle.svg";
import Notification from "../../assets/images/icon/notification.svg";
import Content from "../../assets/images/icon/content.svg";
import Email from "../../assets/images/icon/email.svg";
import Profile from "../../assets/images/icon/profile.svg";



function Sidenav({ color }) {
  const { pathname } = useLocation();
  const page = pathname.replace("/", "");
  return (
    <>
      <div className="brand">
        <a href="/">
          <img src={Logo} alt="" />
          <p>Data Solutions</p>
        </a>
      </div>
      <hr />
      <Menu theme="light" mode="inline">
        <Menu.Item key="1">
          <NavLink to="/dashboard">
            <span
              className="icon"
              style={{
                background: page === "dashboard" ? color : "",
              }}
            >
              <img src={Dashboard01} />
            </span>
            <span className="label">Dashboard</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="11">
          <NavLink to="/file-manager">
            <span
              className="icon"
              style={{
                background: page === "file-manager" ? color : "",
              }}
            >
              <i class="fas fa-file"></i>
            </span>
            <span className="label">File Manager</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="12">
          <NavLink to="/location-manager">
            <span
              className="icon"
              style={{
                background: page === "location-manager" ? color : "",
              }}
            >
              <i class="fas fa-map-marker"></i>
            </span>
            <span className="label">Location Manager</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="13">
          <NavLink to="/project-manager">
            <span
              className="icon"
              style={{
                background: page === "project-manager" ? color : "",
              }}
            >
              <i class="fas fa-project-diagram"></i>
            </span>
            <span className="label">Project Manager</span>
          </NavLink>
        </Menu.Item>

        <Menu.Item key="25">
          <NavLink to="/type-manager">
            <span
              className="icon"
              style={{
                background: page === "type-manager" ? color : "",
              }}
            >
              <i class="fas fa-project-diagram"></i>
            </span>
            <span className="label">Type Manager</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="22">
          <NavLink to="/top-data">
            <span
              className="icon"
              style={{
                background: page === "top-data" ? color : "",
              }}
            >

              <i class="fas fa-database"></i>
              {/* <i class="fas fa-project-diagram"></i> */}
            </span>
            <span className="label">Top Data</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="23">
          <NavLink to="/db-coloum">
            <span
              className="icon"
              style={{
                background: page === "db-coloum" ? color : "",
              }}
            >

              <i class="fas fa-columns"></i>
              {/* <i class="fas fa-project-diagram"></i> */}
            </span>
            <span className="label">DB Coloum</span>
          </NavLink>
        </Menu.Item>
        {/* <Menu.Item key="14">
          <NavLink to="/category-manager">
            <span
              className="icon"
              style={{
                background: page === "category-manager" ? color : "",
              }}
            >
              <img src={Loyalty} />
            </span>
            <span className="label">Category Manager</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="15">
          <NavLink to="/product-manager">
            <span
              className="icon"
              style={{
                background: page === "product-manager" ? color : "",
              }}
            >
              <img src={Loyalty} />
            </span>
            <span className="label">Product Manager</span>
          </NavLink>
        </Menu.Item> */}
        {/* 
        <Menu.Item key="13">
          <NavLink to="/notification-manager">
            <span
              className="icon"
              style={{
                background: page === "notification-manager" ? color : "",
              }}
            >
              <img src={Notification} />
            </span>
            <span className="label">Notification Manager</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="16">
          <NavLink to="/content-manager">
            <span
              className="icon"
              style={{
                background: page === "content-manager" ? color : "",
              }}
            >
              <img src={Content} />
            </span>
            <span className="label">Content Manager</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="17">
          <NavLink to="/email-template-manager">
            <span
              className="icon"
              style={{
                background: page === "email-template-manager" ? color : "",
              }}
            >
              <img src={Email} />
            </span>
            <span className="label">Email Templates</span>
          </NavLink>
        </Menu.Item> */}

        <Menu.Item key="5">
          <NavLink to="/profile">
            <span
              className="icon"
              style={{
                background: page === "profile" ? color : "",
              }}
            >
              <i class="fas fa-user-circle"></i>
            </span>
            <span className="label">Profile</span>
          </NavLink>
        </Menu.Item>


      </Menu >

    </>
  );
}

export default Sidenav;
